export class UnauthorizedError extends Error {
  override readonly name = 'UnauthorizedError';
  constructor() {
    super('Unauthorized');
  }
}

export class NetworkError extends Error {
  override readonly name = 'NetworkError';
  constructor() {
    super('Network error');
  }
}

export class ServerError extends Error {
  override readonly name = 'ServerError';
  constructor() {
    super('Server error');
  }
}

export class SavedMealNotFoundError extends Error {
  override readonly name = 'SavedMealNotFoundError';
  constructor() {
    super('Saved meal not found');
  }
}

export class InvalidSavedMealInputError extends Error {
  override readonly name = 'InvalidSavedMealInputError';
  constructor(message = 'Invalid saved meal input') {
    super(message);
  }
}

export type SavedMealError =
  | UnauthorizedError
  | NetworkError
  | ServerError
  | SavedMealNotFoundError
  | InvalidSavedMealInputError;
